<template >
  <CContainer
    class="d-flex bg-custom align-items-center justify-content-center min-vw-100 min-vh-100"
  >
    <CRow class="width-custom justify-content-center">
      <CCol md="12" lg="12">
        <CCard class="p-4 color-custom">
          <CCardBody>
            <CForm class="d-flex flex-column justify-content-center">
              <div class="mb-2 border-custom align-self-center">
                <CImg :src="image" align="center" width="120" height="120" class="m-0" />
              </div>

              <!-- <CImg
                :src="image"
                align="center"
                width="150"
                height="150"
                class="mb-2 border-custom"
              />-->
              <h2 class="text-center">Nueva contraseña</h2>
              <CAlert v-if="error" color="danger">{{ error }}</CAlert>
              <CAlert v-if="success" color="success">{{ success }}</CAlert>
              <CInput
                :value.sync="$v.password.$model"
                :isValid="checkIfValid('password')"
                placeholder="Nueva contraseña..."
                type="password"
                autocomplete="curent-password"
                invalidFeedback="Campo requerido, mínimo 4 caracteres, máximo 16 caracteres"
              >
                <template #prepend-content>
                  <CIcon name="cil-lock-locked" />
                </template>
              </CInput>

              <CInput
                :value.sync="$v.confirmPassword.$model"
                :isValid="checkIfValid('confirmPassword')"
                class="mb-0"
                placeholder="Confirmar contraseña..."
                type="password"
                autocomplete="curent-password"
                invalidFeedback="La contraseña no es igual"
              >
                <template #prepend-content>
                  <CIcon name="cil-lock-locked" />
                </template>
              </CInput>
              <div v-if="isLoading" class="w-100 d-flex justify-content-center align-items-center">
                <div class="sk-flow d-flex align-items-center">
                  <div class="sk-flow-dot bg-primary"></div>
                  <div class="sk-flow-dot bg-primary"></div>
                  <div class="sk-flow-dot bg-primary"></div>
                </div>
              </div>
              <CRow class="px-3 mt-3" alignHorizontal="center">
                <!-- <router-link class="btn-custom-width" :to="{ name: 'Home'}"> -->
                <CButton @click="getRecuperar()" class="btn-custom-width" color="primary">Enviar</CButton>
                <!-- </router-link> -->
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      size="sm"
      title="Cambio de contraseña"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
    >{{ error }}</CModal>
    <CModal
      size="sm"
      title="Cambio de contraseña"
      :centered="true"
      color="primary"
      :show.sync="successModal"
    >{{ success }}</CModal>
  </CContainer>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  sameAs
} from "vuelidate/lib/validators";

import logo from "../assets/images/Logo-Vertical-Blanco.png";

export default {
  name: "RecoveryPsChange",
  data() {
    return {
      mail: this.$route.params.mail,
      token: this.$route.params.token,
      image: logo,
      claveEmpresa: this.$route.params.ambito,
      error: "",
      warningModal: false,
      successModal: false,
      isLoading: false,
      success: "",
      password: "",
      confirmPassword: ""
    };
  },

  mixins: [validationMixin],
  validations: {
    password: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(16)
    },
    confirmPassword: {
      sameAsPassword: sameAs("password")
    }
  },

  computed: {
    isValidPassword() {
      return !this.$v.password.$invalid;
    },
    isValidConfirmPassword() {
      return !this.$v.confirmPassword.$invalid;
    }
  },

  methods: {
    getRecuperar() {
      this.validateRecuperar();

      if (this.isValidPassword && this.isValidConfirmPassword) {
        this.isLoading = true;

        this.$store
          .dispatch("recoverChangePassword", {
            clave_empresa: this.claveEmpresa,
            correo: this.mail,
            token_recuperar: this.token,
            contrasena_nueva: this.password
          })
          .then(() => {
            this.isLoading = false;

            this.success = "Cambio de contraseña exitoso";
            this.resetCambio();
            this.$router.push({ name: "Login" });
          })
          .catch(rej => {
            this.isLoading = false;

            this.error = rej.message;
            // this.warningModal = true;
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateRecuperar() {
      this.$v.password.$touch();
      this.$v.confirmPassword.$touch();
    },
    resetCambio() {
      this.password = "";
      this.confirmPassword = "";
      this.$v.password.$reset();
      this.$v.confirmPassword.$reset();
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.bg-custom {
  background-color: #3c4b64 !important;
  margin: 0 !important;
}
.color-custom {
  background-color: rgba(255, 255, 255, 1);
}
.border-custom {
  border-radius: 50% !important;
  background-color: #3c4b64 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 160px;
  width: 160px;
}
.width-custom {
  width: 450px;
}
.btn-custom-width {
  width: 100%;
}
.link-underline {
  text-decoration: underline;
}
</style>
